import { fetchRecommendationResults, fetchProductResults } from "clerkUtils";

class ClerkRecommendations extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId ? JSON.parse(this.dataset.productId) : null;
    this.label = this.dataset.label;
    this.limit = this.dataset.limit ? Number(this.dataset.limit) : null;
  }

  connectedCallback() {
    this.init();
  }

  renderProductResults(productCards) {
    if (this.limit) {
      productCards = productCards.slice(0, this.limit)
    }
    productCards.forEach((element) => this.appendChild(element));

    Clerk("click", "*[data-clerk-product-id]");
  }

  init() {
    const type = this.dataset.type;
    fetchRecommendationResults(
      type,
      (urls) => {
        const params = {
          urls: urls,
          view: "clerk-item-slide",
          callback: (elements) => this.renderProductResults(elements),
        };

        fetchProductResults(params);
      },
      this.productId,
      this.label
    );
  }
}

if (!customElements.get("clerk-recommendations")) {
  customElements.define("clerk-recommendations", ClerkRecommendations);
}
